import Equalizer from '../../utils/equalizer';

export default class CarSpecsCompareAccordion {
    constructor(el) {
        this.el = el;
    }

    toggle(element) {
        const clickT = element.getAttribute('data-selected-text');
        const modelSelected = element.getAttribute('data-model-name');
        const moduleName = element.getAttribute('data-module-name');
        const accIndex = element.getAttribute('data-group-acc');
        const allClass = this.el.querySelectorAll(`[data-group-acc='${accIndex}']`);
        let panelHeight = 0;
        let expandedElement = [];
        const firstAccordianDetail = allClass[0].closest('div');
        const listOfAccordian = firstAccordianDetail.querySelectorAll('li');
        listOfAccordian.forEach((item, index) => {
            if (!allClass[0].classList.value.includes('active')) {
                Equalizer.equalizeItems(this.el.querySelectorAll(`[data-group-acc='${accIndex}'] + div li:nth-child(${ index + 1 })`));
            } else {
                const blocks = this.el.querySelectorAll(`[data-group-acc='${accIndex}'] + div li:nth-child(${ index + 1 })`);
                blocks.forEach((item2) => {
                    item2.style.removeProperty('min-height');
                });
            }
        });
        allClass.forEach((item3, index) => {
            item3.classList.toggle('active');
            item3.querySelector('[aria-expanded]').setAttribute('aria-expanded', item3.classList.contains('active'));
            const panel = item3.nextElementSibling;
            panelHeight = panel.scrollHeight > panelHeight ? panel.scrollHeight : panelHeight;
            if (panel.style.minHeight) {
                panel.style.minHeight = null;
            } else {
                expandedElement.push(panel);
                if (index === 0) {
                    window.dataLayer.push({
                        event: 'compare_grades_details',
                        eventCategory: 'compare grades details',
                        eventAction: 'CTA click',
                        eventLabel: `${moduleName}|${clickT}|internal|${modelSelected}|#`,
                        actionType: 'CTA click',
                        moduleName: `${moduleName}`,
                        clickText: `${clickT}`,
                        clickType: 'internal',
                        modelSelected: `${modelSelected}`,
                        destinationURL: '#',
                    });
                }
            }
        });
        expandedElement.forEach((item) => {
            const temp = item;
            temp.style.minHeight = `${panelHeight}px`;
        });
        expandedElement = [];
    }

    showAll() {
        const accordionHeadingToggle = this.el.querySelectorAll('.accordion-heading-toggle');
        accordionHeadingToggle.forEach((item, index) => {
            item.addEventListener('click', (e) => {
                if (e.currentTarget?.parentElement) {
                    this.toggle(e.currentTarget.parentElement);
                }
            });
            if (index === 0) {
                item.click();
            }
        });
    }
}
